import { all, call, put } from 'redux-saga/effects';

import { $httpRootApi } from '@core/http-client';
import { segmentsActions } from '@redux/reducers/common/segments/segmentsReducer';
import { getDefaultError } from '@shared/utils/common';

export function* getSegmentsSaga() {
  try {
    yield put(segmentsActions.setLoading(true));

    const { regions, countries, team, society } = yield all({
      regions: call(() => $httpRootApi.get(`segments/regions`)),
      countries: call(() => $httpRootApi.get(`segments/counties`)),
      team: call(() => $httpRootApi.get(`segments/team`)),
      society: call(() => $httpRootApi.get(`segments/society`)),
    });

    yield put(
      segmentsActions.getSegmentsSuccess({
        regions: regions.data.data,
        countries: countries.data.data,
        team: team.data.data,
        society: society.data.data,
      })
    );
  } catch (e) {
    yield put(segmentsActions.getSegmentsFailure(getDefaultError(e?.response?.data?.message)));
  }
}
